import type { LucideIcon } from "lucide-react";

import { StevieStatusIcon } from "./StevieStatusIcon";
import { stevieStatusCardClassName } from "./stevieStatusStyles";

import { Column, Row, Text } from "@/components";

import { cn } from "@/lib/utils";
import {
  CallStructuredSummaryField,
  CallStructuredSummaryStatus,
} from "@/types";

// The top-line read: four tinted cards a recruiter can scan before reading
// anything else. Not clickable — their evidence lives in the rows below.
export const StevieMetricCard = ({
  field,
  hideStatusIcon = false,
  Icon,
  label,
}: {
  field: CallStructuredSummaryField;
  // Catalogs that do not grade an answer against a role show no status marker.
  hideStatusIcon?: boolean;
  Icon?: LucideIcon;
  label: string;
}) => {
  /* Helpers */
  const isUnknown = field.status === CallStructuredSummaryStatus.UNKNOWN;

  /* Render */
  const render = () => {
    return (
      <Column
        className={cn(
          "relative min-w-0 gap-2 rounded-lg px-4 py-3",
          stevieStatusCardClassName(field.status),
        )}
      >
        <Text className="font-plex-mono text-[11px] font-medium uppercase tracking-wider text-slate-500">
          {label}
        </Text>
        <Row className="items-center gap-2">
          {Icon ? (
            <Icon
              className="h-4 w-4 shrink-0 text-slate-400"
              strokeWidth={1.5}
            />
          ) : null}
          <Text
            className={cn(
              "text-base font-medium",
              isUnknown ? "text-slate-400" : "text-slate-800",
            )}
          >
            {isUnknown ? "N/A" : (field.value ?? "N/A")}
          </Text>
        </Row>
        {field.detail ? (
          <Text className="pl-6 text-xs font-normal text-slate-500">
            {field.detail}
          </Text>
        ) : null}
        {hideStatusIcon ? null : (
          <StevieStatusIcon
            className="absolute right-3 top-3"
            status={field.status}
          />
        )}
      </Column>
    );
  };

  return render();
};
